<template>
  <div class="section-latest-game-released" id="slot-section">
    <div class="container space-top">
      <div class="nav-bar-games">
        <div class="left">
          <p class="title">Slots</p>
        </div>
        <button
          class="view-button all-slots_btn-show"
          @click="redirectToGamesPage"
        >
          View All Games
        </button>
      </div>
      <p class="description">
        Our slots portfolio offers content composed of different games,
        available in many currencies, and soon in all languages and all major
        certified markets.
      </p>
      <div class="list-released-games">
        <div class="slot-list">
          <div
            class="game-card"
            v-for="game in filteredGames"
            :key="game.id"
            @click="launchGames(game.game_id)"
          >
            <!-- <img
              class="slot-game-thumb"
              :src="getGameThumbnail(game.game_id)"
              :alt="game.name"
            /> -->
            <img
              class="slot-game-thumb"
              :src="`${getGameThumbnail(game.game_id)}?t=1`"
              :alt="game.name"
              @error="setFallbackImage($event)"
            />
            <p class="slot-game-name text-center">{{ game.name }}</p>
            <button v-if="isWindowWideEnough" class="play-button">
              Play Now
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "PreviewGamesHomePage",
  components: {},

  data() {
    return {
      lang: localStorage.getItem("language") ?? "en",
      token: "demo",
      publicPath: process.env.VUE_APP_PUBLIC_PATH ?? "/",
      currency: sessionStorage.getItem("currency") ?? "EUR",
      isWindowWideEnough: window.innerWidth > 600,
      fallbackImage: "/assets/images/logo.png",
    };
  },
  computed: {
  ...mapGetters("casinoGames", ["games", "isLoadingCardGames"]),
  filteredGames() {
    return this.games?.games
      ?.filter(game => game.coming_soon !== 1) // esclude i giochi in coming soon
      .reverse()
      .slice(0, 3);
   },
  },
  mounted() {
    window.addEventListener("resize", this.updateWindowWidth);
  },
  created() {
    let lang = localStorage.getItem("language") ?? "en";
    this.$router.push({ params: { lang: lang } });
    this.$store.dispatch("casinoGames/callEarGames");
  },
  methods: {
    play(id, token) {
      this.$router.push(`/gameDetail/${id}/${token}`);
    },
    launchGames(game_id, token) {
      token = this.token;
      this.play(game_id, token);
    },
    getGameThumbnail(game_id) {
      return `https://storage.googleapis.com/camasy-images/casino/theearcasino/${game_id}.png`;
    },
    setFallbackImage(event) {
      event.target.src = this.fallbackImage;
    },
    updateWindowWidth() {
      this.isWindowWideEnough = window.innerWidth > 600;
    },
    redirectToGamesPage() {
      this.$router.push(`/${this.lang}/games`);
    },
  },
};
</script>

<style lang="scss">
.section-latest-game-released {
  background-color: #09041f;
  position: relative;
  background-size: cover;
  text-align: left;
  padding: 26px 0 94px;
}

.section-latest-game-released .container {
  max-width: 1320px;
  width: 100%;
}

.section-latest-game-released .space-top {
  padding-top: 70px;
}

.container .nav-bar-games {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -ms-flex-align: center;
  align-items: center;
  margin-bottom: 50px;
}

.section-latest-game-released > .container .nav-bar-games .left {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-pack: center;
  justify-content: center;
  -ms-flex-align: center;
  align-items: center;
}

.section-latest-game-released > .container .nav-bar-games .left .title {
  font-size: 40px;
  font-weight: 600;
  color: #fff;
  margin: 0;
  letter-spacing: 1px;
  line-height: 1.25;
}

.section-latest-game-released > .container .nav-bar-games .view-button {
  margin: 15px 0px;
  font-size: 16px;
  font-weight: 600;
  color: white;
  padding: 13px 13px;
  border-radius: 25px;
  border: 2px solid rgb(45, 113, 239);
  transition: 0.3s all;
  width: auto;
  max-width: 300px;
}

.view-button:hover {
  color: white;
  font-size: 16px;
  background: rgb(45, 113, 239);
  border: 2px solid rgb(45, 113, 239);
  box-shadow: 0px 0px 15px 5px cornflowerblue;
  cursor: pointer;
}

.section-latest-game-released > .container .description {
  margin: 0 0 50px;
  font-size: 16px;
  color: #fff;
  line-height: 1.75;
  text-align: left;
  letter-spacing: normal;
}

.slot-list {
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  justify-content: space-between;
}

.slot-list-wrapper {
  width: 100%;
  min-height: 50vh;
  max-width: 1340px;
  margin: 0 auto;
}

.game-card {
  margin: 0px 0px 15px;
  position: relative;
}
.play-button {
  opacity: 0;
  transition: opacity 0.3s;
}

.game-card:hover .play-button {
  opacity: 1;
}
.play-button {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0;
  background: linear-gradient(to right, rgb(96, 115, 236), rgb(19, 54, 193));
  color: white;
  font-size: 14px;
  font-weight: 500;
  font-family: "Montserrat", sans-serif;
  line-height: 1.25;
  padding: 10px 20px;
  border-radius: 999px;
  max-width: 150px;
  max-height: 100px;
  z-index: 3;
  transition: 0.3s all;
}

.play-button:hover {
  background: linear-gradient(to right, rgb(92, 104, 187), rgb(23, 47, 143));
  color: white;
  text-decoration: underline;
  font-weight: 300;
  transition: 0.1s all;
}

.slot-game-thumb {
  -o-object-fit: contain;
  object-fit: contain;
  transition: 0.3s all;
  height: 180px;
  max-width: 320px;
  cursor: pointer;
}

.slot-game-name {
  font-family: "Montserrat", sans-serif;
  font-size: 1.3rem;
  font-weight: 600;
  line-height: 1.2;
  margin: 10px 0px 10px 0px;
  color: white;
}

@media (max-width: 768px) {
  .section__title {
    font-size: 30px;
    text-transform: uppercase;
    font-weight: 700;
    font-family: "Montserrat", sans-serif;
  }
  .section__subtitle {
    font-size: 18px;
    margin: 0 0 30px;
    font-weight: 600;
    font-family: "Montserrat", sans-serif;
  }
}

@media (max-width: 1200px) and (min-width: 321px) {
  .section-latest-game-released {
    background-color: #09041f;
    position: relative;
    background-size: cover;
    text-align: left;
    padding: 26px 10px 94px;
  }
  .slot-list {
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    justify-content: space-around;
    padding: 25px 10px 0px;
  }

  .game-card {
    margin: 0px 0px 15px;
    position: relative;
    /* max-width: 49%; */
    max-width: 100%;
  }

  .slot-game-thumb {
    -o-object-fit: contain;
    object-fit: contain;
    transition: 0.3s all;
    height: 120px;
    width: 100%;
    cursor: pointer;
  }

  .slot-game-name {
    font-family: "Montserrat", sans-serif;
    font-size: 1rem;
    font-weight: 600;
    line-height: 1.2;
    margin: 5px 0px 10px 0px;
  }
}

@media (max-width: 480px) {
  .section-latest-game-released .space-top {
    padding-top: 30px;
  }
  .section-latest-game-released > .container .nav-bar-games .left .title {
    font-size: 30px;
    font-weight: 600;
    color: #fff;
    margin: 0;
    letter-spacing: 1px;
    line-height: 1.25;
  }
  .section-latest-game-released > .container .description {
    margin: 0 0 50px;
    font-size: 15px;
    color: #fff;
    line-height: 1.75;
    text-align: center;
    letter-spacing: normal;
  }

  .section-latest-game-released > .container .nav-bar-games .view-button {
    margin: 0px;
    font-size: 16px;
    font-weight: 600;
    color: white;
    padding: 13px 18px;
    border-radius: 25px;
    border: 2px solid rgb(45, 113, 239);
    transition: 0.3s all;
  }
  .slot-list {
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    justify-content: space-around;
    padding: 25px 10px 0px;
  }
  .game-card {
    margin: 0px 0px 30px;
    position: relative;
  }

  .slot-game-thumb {
    -o-object-fit: contain;
    object-fit: contain;
    transition: 0.3s all;
    height: 120px;
    width: 100%;
    cursor: pointer;
  }

  .slot-game-name {
    font-family: "Montserrat", sans-serif;
    font-size: 1.2rem;
    font-weight: 600;
    line-height: 1.2;
    margin: 5px 0px 10px 0px;
  }

  .nav-bar-games {
    display: flex;
    justify-content: space-between !important;
    align-items: center;
    flex-wrap: wrap;
    margin-bottom: 30px;
  }
}

#slot-section {
  position: relative;

  &:before {
    content: "";
    position: absolute;
    width: 100%;
    top: 0;
    left: 0;
    display: block;
    background: #09041f;
    height: 100%;
    z-index: -1;
  }
}
</style>
